<template>
  <div>
    <b-row>
      <b-col>
        <b-form-select v-model="$parent.$parent.selected_ship" :options="$parent.$parent.ships" :title="getSelectedShipTooltip" v-b-tooltip.hover size="sm"></b-form-select>
      </b-col>
      <b-col>
        <b-button variant="info" size="sm" @click="checkUpdates()">{{ $t('deliveries.checkUpdates') }}</b-button>
      </b-col>
      <b-col class="ml-auto text-right">
        <b-button variant="warning" size="sm" @click="downloadCertificates()" :disabled="isDownloadingCertificates">
          <b-spinner small v-if="isDownloadingCertificates" class="mr-2"></b-spinner>
          Download Certificates
        </b-button>
      </b-col>
    </b-row>

    <b-table v-if="deviceStore.getDeliveriesCount > 0"
             ref="deliveriestable"
             class="secondary mt-2"
             fixed
             :busy="isBusy"
             :stacked="is_mobile"
             :items="items_ships()"
             :fields="visible_fields_ships"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             select-mode="single"
             selectable
             show-empty
             responsive
             sort-icon-left
             small
             hover
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>&nbsp;{{ $t('deliveries.loading') }}</strong>
        </div>
      </template>
      <template #cell(url)="row">
        <b-link :href="getDownloadLink(row.item.url)" class="smt17">{{ $t('deliveries.download') }}</b-link>
      </template>

      <template #cell(timestamp)="row">
        {{ dayjs(row.item.timestamp).format("DD-MMM-YY HH:mm") }}
      </template>

      <template #cell(order)="row">
        #{{ row.item.order }}
      </template>

      <template #cell(size)="row">
        {{ niceBytes(row.item.size) }}
      </template>

      <template #cell(content)="row">
        <h6>
          <b-badge :variant=getTypeStatus(row.item.type).style>{{ getTypeStatus(row.item.type).name }}</b-badge>&nbsp;
        </h6>
      </template>

      <template #cell(type)="row">
        <h6>
          <b-badge :variant=getTypeStatus(row.item.subType).style>{{ getTypeStatus(row.item.subType).name }} {{getOrderId(row.item) }}</b-badge>
        </h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import {mapStores} from "pinia";
import {useMomentaryStore} from "@/stores/momentary";
import {useUserStore} from "@/stores/user";
import {loadDeliveries, loadDeliveries1} from "@/helpers/api";
import dayjs from "dayjs";
import {useDeviceStore} from "@/stores/device";
import {downloadProductCertificate, downloadProductCertificateAttachment} from "@/helpers/apiServices";

export default {
  name: "Deliveries",
  data() {
    return {
      windowWidth: window.innerWidth,
      sortBy: 'createdAt',
      sortDesc: true,
      sortDirection: 'desc',
      isBusy: false,
      isDownloadingCertificates: false,
      filterOn: [],
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    this.checkUpdates()
  },
  computed: {
    is_mobile() {
      return this.windowWidth <= 760
    },
    ...mapStores(useUserStore, useMomentaryStore, useDeviceStore),
    visible_fields_ships() {
      return [
        {
          key: 'content', label: this.$t('deliveries.content'), sortable: true, sortDirection: 'desc',
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'type', label: this.$t('deliveries.type'), sortable: true, sortDirection: 'desc',
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'timestamp', label: this.$t('deliveries.date'), sortable: true, sortDirection: 'desc',
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'size', label: this.$t('deliveries.size'), sortable: true, sortDirection: 'desc',
          tdClass: 'small-black', thClass: 'small-gray'
        },
        {
          key: 'url', label: this.$t('deliveries.download'), sortable: true, sortDirection: 'desc',
          tdClass: 'small-black', thClass: 'small-gray'
        },
      ]
    },

  },
  methods: {
    dayjs,
    getDownloadLink(url) {
      return url
    },
    getSelectedShipTooltip() {
      let tooltip = ''
      if (this.$store.state.auth.user.role === 'distributor') {
        let deviceId = this.$parent.$parent.selected_ship;
        let ship = this.$parent.$parent.ships.find(e => e.value === deviceId);
        tooltip = ship?.email + ", " + deviceId;
      }
      return tooltip
    },
    niceBytes(x) {
      const units = [this.$t('deliveries.bytes'), this.$t('deliveries.kib'), this.$t('deliveries.mib'), this.$t('deliveries.gib'), this.$t('deliveries.tib'), this.$t('deliveries.pib'), this.$t('deliveries.eib'), this.$t('deliveries.zib'), this.$t('deliveries.yib')];
      let l = 0, n = parseInt(x, 10) || 0;
      while (n >= 1024 && ++l) {
        n = n / 1024;
      }
      return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    },
    checkUpdates() {
      if (!this.deviceStore.isDeviceIDExist)
        return

      this.isBusy = true;
      loadDeliveries(this.deviceStore.getDeviceID)
      loadDeliveries1(this.deviceStore.getDeviceID, "2024-12-06T10:16:06.695Z").then((response) => {
        this.isBusy = false;
      })
    },
    /**
     * Скачать два сертификата для выбранного корабля
     * Загружает оба PDF файла и предлагает их браузеру для скачивания
     */
    async downloadCertificates() {
      // Проверяем, что корабль выбран
      const deviceId = this.deviceStore.getDeviceID;
      if (!deviceId) {
        alert('Please select a ship first');
        return;
      }

      // Устанавливаем флаг загрузки
      this.isDownloadingCertificates = true;
      
      try {
        console.log('[DownloadCertificates] Начинаем скачивание сертификатов для корабля:', deviceId);
        
        // Скачиваем оба сертификата параллельно
        const [cert1Blob, cert2Blob] = await Promise.all([
          downloadProductCertificate(deviceId),
          downloadProductCertificateAttachment(deviceId)
        ]);

        console.log('[DownloadCertificates] Сертификаты успешно загружены, размеры:', {
          cert1: cert1Blob.size,
          cert2: cert2Blob.size
        });

        // Скачиваем первый сертификат
        this.triggerDownload(cert1Blob, `product_certificate_${deviceId}.pdf`);
        
        // Скачиваем второй сертификат с задержкой (для того чтобы браузер успел обработать первый)
        setTimeout(() => {
          this.triggerDownload(cert2Blob, `product_certificate_attachment_${deviceId}.pdf`);
        }, 500);

        // Показываем уведомление об успехе
        this.$bvToast.toast('Certificates downloaded successfully', {
          title: 'Download Complete',
          variant: 'success',
          solid: true,
          autoHideDelay: 4000,
        });

      } catch (error) {
        console.error('[DownloadCertificates] Ошибка при скачивании сертификатов:', error);
        
        // Показываем сообщение об ошибке пользователю
        alert(`Error downloading certificates: ${error.message || 'Unknown error'}`);
      } finally {
        // Снимаем флаг загрузки
        this.isDownloadingCertificates = false;
      }
    },

    /**
     * Вспомогательный метод для инициирования скачивания файла
     * Создает временную ссылку и кликает по ней для скачивания
     * 
     * @param {Blob} blob - Данные файла
     * @param {string} filename - Имя файла для скачивания
     */
    triggerDownload(blob, filename) {
      try {
        // Создаем временный URL для blob'а
        const url = window.URL.createObjectURL(blob);
        
        // Создаем временный элемент <a> для скачивания
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.style.display = 'none';
        
        // Добавляем ссылку в DOM
        document.body.appendChild(link);
        
        // Кликаем по ссылке для инициирования скачивания
        link.click();
        
        // Удаляем ссылку из DOM
        document.body.removeChild(link);
        
        // Освобождаем объект URL
        window.URL.revokeObjectURL(url);
        
        console.log('[TriggerDownload] Файл скачан:', filename);
      } catch (err) {
        console.error('[TriggerDownload] Ошибка при скачивании файла:', err);
        throw err;
      }
    },
    items_ships() {
      return this.deviceStore.getDeliveries
    },
    getTypeStatus(status) {
      let val = {}
      switch (status) {
        case 'Full':
          val = {style: "info", name: this.$t('deliveries.fullSet')}
          break
        case 'Update':
          val = {style: "warning", name: this.$t('deliveries.regularUpdate')}
          break
        case 'NewOrder':
          val = {style: "success", name: this.$t('deliveries.order')}
          break
        default:
          val = {style: "light", name: status}
      }
      return val
    },
  getOrderId(item) {
    let orderId = ''
    if (item.orderId)
      orderId = ': ' + item.orderId

    return orderId
  }

  },
}
</script>

<style>
.position-absolute {
  position: fixed !important;
}
</style>


<style scoped>
.truncate_name {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>